import ScalarSidebarGroup_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarGroup.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar/ScalarSidebarGroup.vue
var ScalarSidebarGroup_default = ScalarSidebarGroup_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarGroup_default as default };

//# sourceMappingURL=ScalarSidebarGroup.vue.js.map